import { useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { getToken } from '@/lib/auth';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function usePushNotifications() {
  const subscribe = useCallback(async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !getToken()) return;

    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;

      const registration = await navigator.serviceWorker.ready;
      const existing = await registration.pushManager.getSubscription();
      if (existing) {
        await api.post('/api/push/subscribe', existing.toJSON());
        return;
      }

      // Fetch VAPID key from backend API, fallback to env
      let vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
      try {
        const { data } = await api.get('/api/push/vapid-key');
        if (data.public_key) vapidKey = data.public_key;
      } catch { /* use env fallback */ }
      if (!vapidKey) return;

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });

      await api.post('/api/push/subscribe', subscription.toJSON());
    } catch (err) {
      console.warn('Push subscription failed:', err);
    }
  }, []);

  useEffect(() => {
    if (getToken()) {
      const timer = setTimeout(subscribe, 2000);
      return () => clearTimeout(timer);
    }
  }, [subscribe]);

  return { subscribe };
}
